import { type ID, ProjectActions } from '@octopus-do/octopus-project-core'
import { commitProjectRequest } from '@storeOld/actionCreators'
import { useDispatch } from 'react-redux'

import { useEditorWrappers } from '../../../hooks'

export const useUpdateContent = (blockId: ID) => {
  const dispatch = useDispatch()

  // todo: fix different content type mapping
  const onChange = (next: unknown) => {
    dispatch(
      commitProjectRequest(
        ProjectActions.blocks.updateContent({
          id: blockId,
          content: next as string,
        })
      )
    )
  }

  const onRename = (next: string) => {
    dispatch(
      commitProjectRequest(
        ProjectActions.blocks.updateTitle({ id: blockId, title: next })
      )
    )
  }

  const { handleChange } = useEditorWrappers(blockId, onChange)

  return {
    onChange: handleChange,
    onRename,
  }
}
